import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/HomePage.css';
import recordingImg from '../assets/recording.png';
import lessonsImg from '../assets/lessons.png';
import liveSoundImg from '../assets/live-sound.png';

const HomePage = () => {
  return (
    <div className='homepage-container'>
      {/* Hero Section */}
      <section className='hero-section'>
        <h1>NOW OFFERING</h1>
        <p>Private In-Home Recording Sessions</p>
      </section>

      {/* <section className='home-service-section bg-light'>
        <div className='home-service-content image-left'>
          <div className='home-service-image'>
            <img src={lessonsImg} alt='Music Lessons' />
          </div>
          <div className='home-service-text'>
            <h2>Lessons & Education</h2>
            <p>
              Whether your child is picking up an instrument for the first time or you're sharpening years of experience, our <Link to='/services/lessons/in-home'>Private In-Home Lessons</Link> and <Link to='/services/lessons/studio'>In-Studio Sessions</Link> are tailored to your unique goals, skill level, and musical interests...
            </p>
            <Link to='/services/lessons' className='service-link'>Learn More</Link>
          </div>
        </div>
      </section> */}

      <section className='home-service-section home-middle'>
        <div className='home-service-content image-right'>
          <div className='home-service-image'>
            <img src={recordingImg} alt='Studio & Production' />
          </div>
          <div className='home-service-text'>
            <h2>Studio & Production</h2>
            <p>
              Ready to record your next single or create stunning visuals to promote it? Our Studio & Production team is here to help. Capture professional-quality sound with our <Link to='/services/studio/recording'>Recording, Mixing & Mastering</Link> services — either in our studio or let our professionals bring our studio to the comfort of your own space with our <strong>Mobile Recording</strong> setup!
              <br /><br />
              Need visuals? We’ve got you covered. Our team offers <Link to='/services/studio/visual'>Professional Photo & Video</Link> services, ideal for live gigs, promo shoots, or in-studio content creation, including graphic designs for logos and promotional flyers. Whether you're looking for a gritty rehearsal vibe or polished press shots, we'll come to you and deliver high-quality media tailored to your vision.
            </p>
            <Link to='/services/studio' className='service-link'>Learn More</Link>
          </div>
        </div>
      </section>

      <section className='home-service-section bg-light'>
        <div className='home-service-content image-left'>
          <div className='home-service-image'>
            <img src={liveSoundImg} alt='Live Sound & Events' />
          </div>
          <div className='home-service-text'>
            <h2>Live Sound & Events</h2>
            <p>
              From small gigs to large venues, our <Link to='/services/live-sound/gear-rental'>Gear Rentals</Link> and <Link to='/services/live-sound/audio-engineer'>Live Sound Engineering</Link> services ensure your performance sounds its best. We provide professional audio solutions tailored to your event needs.
            </p>
            <Link to='/services/live-sound' className='service-link'>Learn More</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
